export default Object.freeze({
  AutomyManaged: 1,
  ExternalManaged: 2,
});
